import type { BoxProps } from '@mui/material';

import NextLink from 'next/link';
import { forwardRef } from 'react';

import { Box, Link } from '@mui/material';

import { paths } from 'src/routes/paths';

import { useTestelopeUserContext } from 'src/testelopeUser/TestelopeUserContext';

export interface LogoProps extends BoxProps {
  disabledLink?: boolean;
  width?: number;
  height?: number;
}

const Logo = forwardRef<HTMLDivElement, LogoProps>(
  ({ disabledLink = false, width, height, sx, ...other }, ref) => {
    const { testelopeUser } = useTestelopeUserContext();

    const logo = (
      <Box
        component="img"
        src="/logo/testelope-simple.svg"
        sx={{ width: width || 40, height: height || 40, cursor: 'pointer', ...sx }}
      />
    );

    if (disabledLink) {
      return logo;
    }

    return (
      <Link
        component={NextLink}
        href={testelopeUser ? paths.dashboard.root : '/'}
        sx={{ display: 'contents' }}
      >
        {logo}
      </Link>
    );
  }
);

export default Logo;
